module.exports = __webpack_public_path__ + "img/orange_square_mobile.87271a18.png";